import { Injectable } from '@angular/core';
import { APIProviderService } from '../api/api.provider.service';
import { Width } from 'src/app/interfaces/width';

@Injectable({
  providedIn: 'root'
})
export class WidthsProviderService extends APIProviderService<Width> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/Widths`;
  }
}
